<script lang="ts">
    import ClearanceAllPaidPurchases from "./ClearanceAllPaidPurchases.svelte";
    import ClearanceSummary from "./ClearanceSummary.svelte";
    import PurchasesToClearanceTable from "./PurchasesToClearanceTable.svelte";

    let counter;
    let sum;
</script>

<section class="employeePurchasesClearance">
    <ClearanceSummary {counter} {sum} />
    <ClearanceAllPaidPurchases {sum} />
    <PurchasesToClearanceTable bind:counter bind:sum />
</section>

